import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { catchError, of } from 'rxjs';
import { TestCaseService } from '../../services/test-case/test-case.service';

@Injectable({ providedIn: 'root' })
export class TestCaseResolver implements Resolve<any> {
  private testCaseService = inject(TestCaseService);

  resolve(route: ActivatedRouteSnapshot) {
    const idParam = route.paramMap.get('testCaseId');
    const id = Number(idParam);

    if (!idParam || Number.isNaN(id)) {
      console.warn('Invalid test case id:', idParam);
      return of(null);
    }

    return this.testCaseService.getAzureDetailsById(id).pipe(
      catchError((err) => {
        console.error('Error loading test case details:', err);
        return of(null);
      }),
    );
  }
}
